import { render, staticRenderFns } from "./PropertyCustomerNewScratch.vue?vue&type=template&id=35ed1b52&scoped=true&lang=pug&"
import script from "./PropertyCustomerNewScratch.vue?vue&type=script&lang=js&"
export * from "./PropertyCustomerNewScratch.vue?vue&type=script&lang=js&"
import style0 from "./PropertyCustomerNewScratch.vue?vue&type=style&index=0&id=35ed1b52&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed1b52",
  null
  
)

export default component.exports